import { gql } from "@apollo/client";

export const QUERY_GET_MATERIAL_COLUMN_CONFIG = `
  GetSavedMaterialColumnHeaders($where: project_users_bool_exp) {
    project_users(where: $where) {
      project_id
      material_column_config
    }
  }
`;

export const QUERY_MATERIAL_EXTRACTED_DATA = `
  extractionDataQuery {
    extraction_data {
      id
      title
      manufacturer
      tag
      table_title
      location: additional_fields(path: "LOCATION")
      grouped_parent_id
      feature_materials_aggregate {
        aggregate {
          count
        }
      }
      spec_page_extract {
        id
        bb_x1
        bb_x2
        bb_y1
        bb_y2
        mark_completed
        page_no
        spec_page {
          id
          page_number
          page_file_key
          width
          height
          specification {
            title
          }
        }
      }
    }
  }
`;

export const QUERY_GET_EXTRACTION_STATUS = gql`
  query getSpecificationsPK($id: uuid!) {
    specifications_by_pk(id: $id) {
      status_comment
      title
    }
  }
`;

export const QUERY_MATERIAL_EXTRACTED_COUNT = gql`
  query RowsExtracted($id: uuid!) {
    extraction_data_aggregate(
      where: {
        spec_page_extract: { spec_page: { specification_id: { _eq: $id } } }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
